import { BrandLockup, Card } from '@classgo/ui';
import type { ReactNode } from 'react';

/**
 * The centered card the sign-in screens share: lockup on top, title, optional subtitle, form.
 */
export const AuthLayout = ({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) => (
  <main className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-10">
    <div className="w-full max-w-sm">
      <div className="mb-6 flex justify-center">
        <BrandLockup height={36} />
      </div>
      <Card>
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        {subtitle ? <p className="mt-1 text-sm text-gray-500">{subtitle}</p> : null}
        <div className="mt-5">{children}</div>
      </Card>
      {footer ? <div className="mt-4 text-center text-sm text-gray-600">{footer}</div> : null}
    </div>
  </main>
);

/**
 * A form-level error, announced to screen readers.
 */
export const FormError = ({ message }: { message: string | null }) =>
  message ? (
    <p role="alert" className="rounded-control bg-danger-100 px-3 py-2 text-sm text-danger-700">
      {message}
    </p>
  ) : null;
